import { useQuery } from '@tanstack/react-query';
import { call } from './api';

/** requests waiting for the user (the menu badge); the inbox refreshes it after every action */
const useInboxCount = (enabled = true) =>
  useQuery({
    queryKey: ['inboxCount'],
    queryFn: () => call<{ total: number }>('count').then((r) => Number(r.result?.total ?? 0)),
    enabled,
    staleTime: 60_000,
    refetchInterval: 120_000,
    refetchOnWindowFocus: true,
    retry: false,
  });

export default useInboxCount;
